const CART_EVENT = {
  RENEWAL_ORDER_REFRESHED: 'RenewalOrderRefreshed',
  SUBMIT: 'CartSubmit',
  SUBMIT_RENEWAL_ORDER: 'CartSubmitRenewalOrder',
};

export {CART_EVENT};
